/* eslint-disable import/no-named-as-default */
import RoomOccupancyEventsDataViewer from './RoomOccupancyEventsDataViewer'
import RoomOccupancyQueryHandler from './RoomOccupancyQueryHandler'
import RoomOccupancySupportDataViewer from './RoomOccupancySupportDataViewer'
import EditRoomCardSettingsAction from './actions/EditRoomCardSettingsAction'

export default {
  install( molten ) {
    molten.addPlugin( 'Action', EditRoomCardSettingsAction )
    molten.addPlugin( 'DataViewer', RoomOccupancySupportDataViewer )
    molten.addPlugin( 'DataViewer', RoomOccupancyEventsDataViewer )
    molten.addPlugin( 'EventQueryOptionsHandler', RoomOccupancyQueryHandler )
  },
}
